<script setup>
import { computed } from 'vue';

// Components
const props = defineProps({
    countTo: {
        type: Number,
        required: true,
    },
    durationCounter: Number,
    delayCounter: Number,
    label: String,
    animationPaused: Boolean,
    icon: String,
    description: String,
});
</script>

<template>
    <div class="flex flex-col items-center justify-start w-full h-full p-5 md:justify-center md:p-10 lg:py-9">
        <div class="flex flex-col items-center gap-4 md:gap-8">
            <number
                v-if="countTo"
                :from="0"
                :to="countTo"
                :duration="durationCounter"
                :delay="delayCounter"
                :animationPaused="animationPaused"
                easing="Power1.easeOut"
                class="font-bold text-white text-[40px] md:text-[60px]"
            />

            <span v-if="label" class="text-sm font-bold text-primary md:text-base" v-html="label"></span>
        </div>

        <span class="mt-2 text-xs text-center md:text-base" v-if="description" v-html="description"></span>
    </div>
</template>
